import React from "react";
import { Button } from "@material-ui/core";
import { useDispatch } from "react-redux";
import { actions as authActions } from "../../Auth/_redux/authRedux";
import { useHistory } from "react-router-dom";

const PageBottomButton = (props) => {
  const dispatch = useDispatch();

  const history = useHistory();

  return (
    <div
      className="d-md-flex d-block container p-0 mx-auto mt-5 text-right"
      style={{ justifyContent: "flex-start", gap: 10 }}
    >
      <Button
        variant="outlined"
        className="col-12 col-md-4 col-lg-3 w-100 my-2 bg-white"
        style={{
          border: "2px solid #ff5050",
          color: "#ff5050",
          height: 45,
          borderRadius: 13,
        }}
        onClick={() => {
          dispatch(authActions.logout());
          history.push("");
        }}
      >
        <h6 className="my-auto" style={{ color: "#ff5050" }}>
          <b>خروج از حساب کاربری</b>
        </h6>
      </Button>
    </div>
  );
};

export default PageBottomButton;
